import Component from '@glimmer/component';
import LineItemModel from 'donor-elf-web/models/line-item';
import { service } from '@ember/service';
import Settings from 'donor-elf-web/services/settings';

interface ComponentArgs {
  lineItem: LineItemModel;
}

interface CustomItem {
  label: string;
  val: any;
  isAmount: boolean;
}

// used for caching purposes
let CustomPropertiesInfo: {
  sortedPropertyLabels?: string[];
  labelIsAmount: { [label: string]: boolean };
} = {
  labelIsAmount: {},
};

export default class LineItemCustomComponent extends Component<ComponentArgs> {
  @service declare settings: Settings;

  get customItem(): CustomItem[] | undefined {
    if (this.args.lineItem.custom == null) {
      return undefined;
    }

    if (CustomPropertiesInfo.sortedPropertyLabels == null) {
      CustomPropertiesInfo.sortedPropertyLabels = [];
      for (let info of this.settings.fundSettings!.lineItemCustomProperties ||
        []) {
        CustomPropertiesInfo.sortedPropertyLabels.push(info.label);
        CustomPropertiesInfo.labelIsAmount[info.label] = info.type === 'amount';
      }
    }

    let items: CustomItem[] = [];
    for (let label of CustomPropertiesInfo.sortedPropertyLabels) {
      if (this.args.lineItem.custom[label] != null) {
        items.push({
          label,
          val: this.args.lineItem.custom[label],
          isAmount: CustomPropertiesInfo.labelIsAmount[label],
        });
      }
    }

    if (Object.keys(this.args.lineItem.custom).length > items.length) {
      for (let label in this.args.lineItem.custom) {
        if (!CustomPropertiesInfo.sortedPropertyLabels.includes(label)) {
          CustomPropertiesInfo.sortedPropertyLabels.push(label);
          CustomPropertiesInfo.labelIsAmount[label] = false;
          items.push({
            label,
            val: this.args.lineItem.custom[label],
            isAmount: CustomPropertiesInfo.labelIsAmount[label],
          });
        }
      }
    }

    return items;
  }
}
